var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWidgetMyszRedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "23m1imj5ba"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 803",
    style: {
      fill: "none"
    },
    d: "M0 0h19v19H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2563"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2562",
    style: {
      clipPath: "url(#23m1imj5ba)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1537",
    d: "M30.685 9.377V0h-8.461a10.293 10.293 0 0 0 8.461 9.377",
    transform: "translate(-11.501)",
    style: {
      fill: "#eb4f5b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1538",
    d: "M9.783 0H0v19.184h19.184V10.33A11.232 11.232 0 0 1 9.783 0M9.4 11.794H4.869a.469.469 0 1 1 0-.938H9.4a.469.469 0 0 1 0 .938m8.044 4.545a.556.556 0 1 1 .433-.656.556.556 0 0 1-.433.656m0-2.427a.556.556 0 1 1 .433-.656.556.556 0 0 1-.433.656",
    style: {
      fill: "#eb4f5b"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetMyszRedIcon);
export default __webpack_public_path__ + "static/media/widget-mysz-red-icon.a041c71f.svg";
export { ForwardRef as ReactComponent };